import React, { useState, useMemo } from 'react';
import moment from 'moment';
import { LoadingSpinner } from 'yankees-react-utils';
import { useOktaQuery, PlayerReport } from '../../../data';
import Header from './Header';
import Calendar from './Calendar';
import PlayLog from './PlayLog';

export default function InGameSpeed({ playerId, gameInfo }) {
    const momentInitialEndDate = moment(gameInfo.gamedate).endOf('day');
    const [showMph, setShowMph] = useState(true);
    const [startDate, setStartDate] = useState(momentInitialEndDate.clone().subtract(13, 'day').startOf('day').toDate());
    const [endDate, setEndDate] = useState(momentInitialEndDate.toDate());
    const { data, isLoading } = useOktaQuery(['inGameSpeed', playerId, startDate, endDate],
        (t) => PlayerReport.inGameSpeed(t, playerId, { startDate, endDate }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const maxSpeed = useMemo(() => (data?.yearmaxes?.find((x) => x.isdenominator)?.maxspeed ?? null), [data?.yearmaxes]);

    return (
        <div className="text-start">
            <Header showMph={showMph} setShowMph={setShowMph} startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} />
            { isLoading ? <div className="py-5 text-center"><LoadingSpinner /></div> : (
                <>
                    <Calendar
                        className="mt-3"
                        endDate={endDate}
                        inGameSpeeds={data?.ingamespeeds.filter((x) => !x.isflagged) ?? []}
                        yearMaxes={data?.yearmaxes ?? []}
                        maxTwoWeekSpeed={data?.maxtwoweekspeed[0]?.maxtwoweekspeed ?? null}
                        maxSpeed={maxSpeed}
                        showMph={showMph}
                    />
                    <PlayLog
                        className="mt-3"
                        inGameSpeeds={data?.ingamespeeds.filter((x) => !x.isflagged) ?? []}
                        maxSpeed={maxSpeed}
                        showMph={showMph}
                        playerId={playerId}
                    />
                </>
            )}
        </div>
    );
}
